import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import Sidenav from "../sidenav";
import "./chart.scss";
import moment from "moment";
import { Button, DatePicker } from "antd";
import { generatePath, Redirect } from "react-router-dom";

const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
const Chart = () => {
  const [humanizeData, setHumanizeData] = useState([]);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [totalHumanize, setTotalHumanizeValue] = useState({
    kudos: 0,
    poll: 0,
    recognition: 0,
    checkin: {
      sunny: 0,
      gloomy: 0,
      okay: 0,
    },
    "thank you": 0,
    "check ins": 0,
  });
  const [selectedDate, setselectedDate] = useState({
    startDate: moment().startOf("month").format(dateFormat),
    endDate: moment().endOf("month").format(dateFormat),
  });
  const [dateFilter, setDateFilter] = useState({
    start: selectedDate.startDate,
    end: selectedDate.endDate,
  });

  const query = new URLSearchParams(window.location.search);
  const token = query.get("token");
  const getHumanizeData = () => {
    fetch(
      `${process.env.REACT_APP_API_URL}/humanize-work/?token=${token}&from=${dateFilter.start}&to=${dateFilter.end}`
    )
      .then((res) => res.json())
      .then((response) => {
        if (response?.statusCode && response?.statusCode === 402) {
          window.location.href = `/subscriptions?token=${token}`;
        } else {
          setHumanizeData(response?.data || []);
        }
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  useEffect(() => {
    getHumanizeData();
  }, [dateFilter]);

  useEffect(() => {
    if (selectedDate.startDate === "" && selectedDate.endDate === "") {
      setDateFilter({
        ...dateFilter,
        start: selectedDate.startDate,
        end: selectedDate.endDate,
      });
    }
  }, [selectedDate]);

  useEffect(() => {
    getTotalHumanizevalue();
  }, [humanizeData]);

  const getTotalHumanizevalue = () => {
    let humanize = {
      kudos: 0,
      poll: 0,
      recognition: 0,
      thank_you: 0,
      totalCheckIn: 0,
      sunny: 0,
      gloomy: 0,
      okay: 0,
    };
    humanizeData.forEach((data) => {
      humanize.totalCheckIn += data.values.totalCheckIn;
      humanize.kudos += data.values.kudos;
      humanize.poll += data.values.poll;
      humanize.recognition += data.values.recognition;
      humanize.thank_you += data.values.thank_you;
      humanize.sunny += data.checkIns.sunny;
      humanize.gloomy += data.checkIns.gloomy;
      humanize.okay += data.checkIns.okay;
    });
    setTotalHumanizeValue({
      Kudos: humanize.kudos,
      Polls: humanize.poll,
      Recognitions: humanize.recognition,
      "Thank You-s": humanize.thank_you,
      "Check-ins": humanize.totalCheckIn,
      checkin: {
        sunny: humanize.sunny,
        gloomy: humanize.gloomy,
        okay: humanize.okay,
      },
    });

    const labels = humanizeData?.map((chartValue) => {
      return `${chartValue.label}`;
    });

    const chartDataSet = {
      labels,
      datasets: getChartDataSet(),
    };
    setChartData(chartDataSet);
  };

  /**
   *
   * @returns
   */
  const getChartDataSet = () => {
    let kudosArray = [];
    let thankyouArray = [];
    let recognitionArray = [];
    let pollArray = [];
    let checkinArray = [];

    humanizeData?.forEach((chartValueData) => {
      checkinArray.push(chartValueData.values.totalCheckIn);
      kudosArray.push(chartValueData.values.kudos);
      thankyouArray.push(chartValueData.values.thank_you);
      recognitionArray.push(chartValueData.values.recognition);
      pollArray.push(chartValueData.values.poll);
    });
    const chartList = [
      checkinArray,
      kudosArray,
      thankyouArray,
      recognitionArray,
      pollArray,
    ];
    const fetchLabel = (data) => {
      switch (data) {
        case 0:
          return ["Check-ins", "rgb(255, 99, 132)", "rgba(255, 99, 132, 0.5)"];
        case 1:
          return ["Kudos", "rgb(51, 231, 231)", "rgba(51, 231, 231, 0.5)"];
        case 2:
          return [
            "Thank You-s",
            "rgb(51, 231, 115)",
            "rgba(51, 231, 115, 0.5)",
          ];
        case 3:
          return [
            "Recognitions",
            "rgb(195, 231, 51)",
            "rgba(195, 231, 51, 0.5)",
          ];
        case 4:
          return ["Polls", "rgb(195, 158, 22)", "rgba(195, 158, 22, 0.5)"];
        default:
          break;
      }
    };
    let dataArray = [];
    chartList.forEach((data, index) => {
      dataArray.push({
        label: fetchLabel(index)[0],
        data,
        backgroundColor: fetchLabel(index)[1],
        borderColor: fetchLabel(index)[2],
      });
    });
    return dataArray;
  };

  const options = {
    ticks: {
      precision: 0,
    },
    scales: {
      y: {
        min: 0,
      },
    },
    responsive: true,
    tension: 0.4,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Humanize Work Graph",
      },
    },
  };

  const handleDateValue = (date, datestring, info) => {
    setselectedDate({
      startDate: datestring[0],
      endDate: datestring[1],
    });
  };

  const handleDateFilter = () => {
    setDateFilter({
      start: selectedDate.startDate,
      end: selectedDate.endDate,
    });
  };

  return (
    <div className="d-flex">
      <Sidenav />
      <div className="flex-1 chart p-4">
        <div className="d-flex align-items-center justify-content-end mb-2 chart-filter">
          <p className="f-14 f-w-600 l-h-normal txt-text-1 me-2">
            Filter by Date :
          </p>
          <RangePicker
            ranges={{
              Today: [moment(), moment()],
              "Last 7 days": [moment().subtract(7, "days"), moment()],
              "Last 30 days": [moment().subtract(1, "month"), moment()],
              "This Month": [
                moment().startOf("month"),
                moment().endOf("month"),
              ],
              "Last Month": [
                moment().subtract(1, "month").startOf("month"),
                moment().subtract(1, "month").endOf("month"),
              ],
              "This Year": [moment().startOf("year"), moment().endOf("year")],
            }}
            defaultValue={[moment().startOf("month"), moment().endOf("month")]}
            format={dateFormat}
            onChange={handleDateValue}
          />
          <Button className="ms-2" type="primary" onClick={handleDateFilter} data-telemetry="Humanize Work: Apply Filter">
            Apply
          </Button>
        </div>
        <div className="d-flex align-items-center w-100 flex-wrap me-auto mb-4 justify-content-center label-container">
          {Object.entries(totalHumanize).map((keyData) => {
            if (keyData[0] !== "checkin") {
              return (
                <div
                  key={keyData[0]}
                  className={`${
                    keyData[0] == "Check-ins" ? "checkin-section" : ""
                  } label-section p-3`}
                >
                  <p className="text-center f-16 f-w-500 txt-text-1 pb-2 mb-1">
                    {keyData[0]}
                  </p>
                  <p className="text-center text-capitalize f-20 f-w-700 txt-primary">
                    {keyData[1]}
                  </p>
                  <div className="checkin-details">
                    {keyData[0] == "Check-ins" ? (
                      <>
                        {Object.entries(totalHumanize.checkin).map(
                          (keyData) => {
                            return (
                              <div
                                key={keyData[0]}
                                className="checking-values d-flex align-items-center justify-content-between"
                              >
                                <p className="text-center text-capitalize f-14 f-w-500 txt-text-1">
                                  {keyData[0]}
                                </p>
                                <p className="text-center text-capitalize f-18 f-w-700 txt-primary">
                                  {keyData[1]}
                                </p>
                              </div>
                            );
                          }
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              );
            }
          })}
        </div>
        <Line
          className="flex-1 chart-container"
          options={options}
          data={chartData}
        />
      </div>
    </div>
  );
};

export default Chart;
